export const confApp = {

// "https://api.s-digitales.com/api/",
// "https://api-pruebas.s-digitales.com/api/",
// "https://localhost:7008/api/",

// LINK_DOC: "https://dev.s-digitales.com/Docs/Negocios",
// LINK_DOC: "https://s-digitales.com/Docs/Negocios",

API_URL: "https://api.s-digitales.com/api/",
LINK_DOC: "https://s-digitales.com/Docs/Negocios",
VERSION: "1.2.02",
  IMAGES_URL: "Images",
  ESTADOS: [
    { label: "Aguascalientes", value: "Aguascalientes" },
    { label: "Baja California", value: "Baja California" },
		{ label: "Baja California Sur", value: "Baja California Sur" },
		{ label:"Campeche", value: "Campeche" },
		{ label: "Chiapas", value: "Chiapas" },
		{ label: "Chihuahua", value: "Chihuahua" },
		{ label: "Ciudad de Mexico", value: "Ciudad de Mexico" },
		{ label: "Coahuila de Zaragoza", value: "Coahuila de Zaragoza" },
		{ label: "Colima", value: "Colima" },
		{ label: "Durango", value: "Durango" },
		{ label: "Guanajuato", value: "Guanajuato" },
		{ label: "Guerrero", value: "Guerrero" },
		{ label: "Hidalgo", value: "Hidalgo" },
		{ label: "Jalisco", value: "Jalisco" },
		{ label: "Mexico", value: "Mexico" },
		{ label: "Michoacan de Ocampo", value: "Michoacan de Ocampo" },
		{ label: "Morelos", value: "Morelos" },
		{ label: "Nayarit", value: "Nayarit" },
		{ label: "Nuevo Leon", value: "Nuevo Leon" },
		{ label: "Oaxaca", value: "Oaxaca" },
		{ label: "Puebla", value: "Puebla" },
		{ label: "Queretaro", value: "Queretaro" },
		{ label: "Quintana Roo", value: "Quintana Roo" },
		{ label: "San Luis Potosi", value: "San Luis Potosi" },
		{ label: "Sinaloa", value: "Sinaloa"},
		{ label: "Sonora", value: "Sonora" },
		{ label: "Tabasco", value: "Tabasco" },
		{ label: "Tamaulipas", value: "Tamaulipas" },
		{ label: "Tlaxcala", value: "Tlaxcala" },
		{ label: "Veracruz de Ignacio de la Llave", value: "Veracruz de Ignacio de la Llave" },
		{ label: "Yucatan", value: "Yucatan" },
		{ label: "Zacatecas", value: "Zacatecas"},
		{ label: "Extranjero", value: "Extranjero"}
  ],
};
